
export default function CaseStats({stats}) {
  return (
    <div onClick={()=>console.log(stats)} className="bg-[#005787] text-white rounded-2xl p-6 shadow-custom">
      <div className="flex items-center justify-between mb-8">
        <h2 className="font-medium">Total Cases</h2>
        <span className="text-2xl">{stats?.TotalLeads || "0"}</span>
      </div>
      <div className="space-y-6">
        <div className="flex justify-between items-center">
          <span className="text-lg">Finished Leads</span>
          <span className="text-lg">{stats?.FinishedLeads || "0"}</span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-lg">Active Leads</span>
          <span className="text-lg">{stats?.ActiveLeads || "0"}</span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-lg">Pending Leads</span>
          <span className="text-lg">{stats?.PendingLeads || "0"}</span>
        </div>
      </div>
    </div>
  )
}